import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/right-arrow.svg";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import presentacionDfVideo from "../assets/avatares/presentacion-df.mp4";
import { useVideoWithSound } from "../hooks/useVideoWithSound";
import "./StartGame.css";

function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const { videoRef } = useVideoWithSound({
		autoPlay: true,
		volume: 0.8,
	});

	const handleStartGame = (e) => {
		e.preventDefault();
		if (loading) return;
		setLoading(true);

		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME2, {
					state: {
						activeScenario: 1,
					},
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<div className="start-game-page">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Dinámica formativa
						</span>
						<div className="start-game-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									playsInline
									preload="auto"
									aria-label="Presentación visual"
								>
									<source src={presentacionDfVideo} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>

					<div className="start-game-panel">
						<p className="start-game-kicker">Paso 1 · Bienvenida</p>
						<h1 className="start-game-title">
							Bienvenido al{" "}
							<span className="start-game-title-accent">
								reto formativo
							</span>
						</h1>
						<p className="start-game-lead">
							Esta dinámica te enfrentará a situaciones clínicas simuladas,
							creadas para entrenar tu toma de decisiones en contextos
							realistas.
						</p>
						<p className="start-game-lead start-game-lead-tight">
							A lo largo del recorrido deberás aplicar tus conocimientos,
							interpretar cada escenario y responder con precisión para
							avanzar correctamente.
						</p>
						<ul className="start-game-points">
							<li>Analiza cada situación con criterio clínico.</li>
							<li>Toma decisiones en el momento adecuado.</li>
							<li>
								Supera cada reto para completar la dinámica formativa.
							</li>
						</ul>
						<div className="start-game-footer">
							<span className="start-game-hint">
								En las siguientes pantallas verás las reglas del reto.
							</span>
							<button
								type="button"
								className="start-game-cta"
								onClick={handleStartGame}
								disabled={loading}
								aria-busy={loading}
							>
								{loading ? (
									<span
										className="start-game-cta-spinner"
										aria-hidden
									/>
								) : (
									<img
										className="start-game-cta-icon"
										src={flechaAvanzar}
										alt=""
									/>
								)}
								{loading ? "Cargando…" : "Continuar"}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default GameIntroduction;
